/**
 * TODO 当前文件属于产品卡片配置文件，通过配置的方式完成业务功能的开发，实现组件的高内聚、低耦合
 * 配置文件说明如下
 *  ProductCfg 对象最外层的包裹文件
 *    planType 规划类型
 *    subType 规划类型下子类型 如： 寿险、年金
 *    insuranceType 保险类型
 *    listPage 列表页模块的配置文件
 *      tableCfg 表格相关配置文件 详情请见 src/components/TsTable/TsTable.vue  表格demo请见 src/components/TsTable/demo.vue
 *      btmBtnList 表格底部按钮数组 接口详情请见 src/types/common/btn.d.ts
 *    editSettings 新增编辑模块配置文件
 *      countUrlFn 分析结果接口函数
 *      inpOutFormList 页面输出项表单数组数据
 */

import { ProductCfg } from '@/types/newPersion'
import { statisticsList } from '@/api/newPersion'
const ProductCfg: ProductCfg = {
  planType: 'Pension',
  subType: 'life',
  insuranceType: 'LifeInsurance',
  listPage: {
    tableCfg: {
      titleObjCfg: {
        // title: '增额终身寿产品选择',
        hide: true,
        options: {
          dropdown: false,
          arr: [
            {
              type: 'add',
              name: '新增终身寿产品'
            }
          ]
        }
      },
      tableHead: [
        {
          propName: '组合名称',
          labelName: '组合名称'
        },
        {
          propName: '修改日期',
          labelName: '修改日期'
        },
        {
          type: 'switch',
          propName: '启用状态',
          labelName: '启用状态',
          activeText: '启用',
          inActiveText: '禁用'
        },
        {
          type: 'edit',
          labelName: '操作',
          propName: 'edit',
          options: {
            dropdown: false,
            arr: [
              {
                type: 'edit',
                name: '编辑',
                btnType: 'text'
              },
              {
                type: 'del',
                name: '删除',
                btnType: 'text'
              }
            ]
          }
        }
      ],
      // listUrlParams: {
      //   insuranceType: 'LifeInsurance',
      //   // storyLineType: 'Pension'
      // }
    },
    btmBtnList: [
      { name: '返回', btnType: 'reset' },
      { name: '查看分析', btnType: 'confirm' }
    ]
  },
  editSettings: {
    countUrlFn: statisticsList,
    formObj: {},
    inpOutFormList: [{
      disabled: true,
      label: '期末身故保障金:',
      suffix: '元',
      type: 'number',
      value: 'lifeBenefits',
      inputWidth: '400px'
    }, {
      disabled: true,
      label: '期末现金价值:',
      suffix: '元',
      type: 'number',
      value: 'cashValue',
      inputWidth: '400px'
    }, {
      disabled: true,
      label: '期末身故保障/总保费:',
      suffix: '倍',
      type: 'number',
      value: 'multiple',
      inputWidth: '400px'
    }, {
      disabled: true,
      label: '期末现金价值/总保费:',
      suffix: '倍',
      type: 'number',
      value: 'valueMultiple',
      inputWidth: '400px'
    }]
  }
}
export default ProductCfg
